export { default } from './Input';
export type { IInput } from './Input';
